import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
import './wizardStyles.css';

const StepDisplay = ({ steps, currentIndex }) => {
  const renderIcon = (status, isCurrent) => {
    switch (status) {
      case 'complete':
        return <CheckCircleOutlineIcon color="success" sx={{ fontSize: '40px' }} />;
      case 'error':
        return <ErrorOutlineIcon color="error" sx={{ fontSize: '40px' }} />;
      default:
        return (
          <PendingOutlinedIcon color={isCurrent ? '' : 'disabled'} sx={{ fontSize: '40px' }} />
        );
    }
  };

  return (
    <div className="evenly-distributed-children">
      {steps &&
        steps.map((e, i) => {
          if (e.showOnStepDisplay) {
            return (
              <div className="wizardItem" key={i}>
                {renderIcon(e.status, currentIndex === i)}
                <div className="wizardStepName">{e.name}</div>
              </div>
            );
          } else {
            return <></>;
          }
        })}
    </div>
  );
};

export { StepDisplay };
